/**
 * @generated SignedSource<<3f96944e99ad96780b76997ce1e0b816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PushTokenAddInput = {
  clientMutationId?: string | null | undefined;
  os: string;
  token: string;
};
export type PushTokenAddMutation$variables = {
  input: PushTokenAddInput;
};
export type PushTokenAddMutation$data = {
  readonly PushTokenAdd: {
    readonly error: string | null | undefined;
  } | null | undefined;
};
export type PushTokenAddMutation = {
  response: PushTokenAddMutation$data;
  variables: PushTokenAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PushTokenAddPayload",
    "kind": "LinkedField",
    "name": "PushTokenAdd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PushTokenAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PushTokenAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7246eb950630301023a4e682a0ee00dc",
    "id": null,
    "metadata": {},
    "name": "PushTokenAddMutation",
    "operationKind": "mutation",
    "text": "mutation PushTokenAddMutation(\n  $input: PushTokenAddInput!\n) {\n  PushTokenAdd(input: $input) {\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9f963b5f656a115731e25d456aab9ba";

export default node;
